import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/blocks/cookie-consent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/hotjar-script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/.pnpm/next-auth@5.0.0-beta.25_next@15.3.6_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19._4dce8af3d5287eaf3a9537d3aaf49f3e/node_modules/next-auth/react.js");
